import { Controller } from "@hotwired/stimulus"

// Phase 2.6 Tier 1 — Risk detail / form interactions.
//
// Toggles the inline assess form on the risk detail page and drives a
// shared styled confirm modal so destructive lifecycle actions
// (Resolve / Close / Reopen / Delete) follow the CLAUDE.md "no
// browser confirm()" convention. Per-action params live on the
// triggering button; this controller wires them into the single modal
// element without duplicating HTML per action.
export default class extends Controller {
  static targets = [
    "assessForm",
    "assessButton",
    "confirmModal",
    "confirmTitle",
    "confirmBody",
    "confirmForm",
    "confirmMethod",
    "confirmSubmit"
  ]
  static values = {
    matrixSize: Number,
    probabilityFactors: Object,
    bands: Object
  }

  connect() {
    // No-op for now. Tier 2 wires live EMV recompute when the user
    // edits residual scores or cost impact in the assess form.
  }

  showAssessForm(event) {
    event.preventDefault()
    if (this.hasAssessFormTarget) {
      this.assessFormTarget.classList.remove("hidden")
    }
    if (this.hasAssessButtonTarget) {
      this.assessButtonTarget.classList.add("hidden")
    }
  }

  hideAssessForm(event) {
    event && event.preventDefault()
    if (this.hasAssessFormTarget) {
      this.assessFormTarget.classList.add("hidden")
    }
    if (this.hasAssessButtonTarget) {
      this.assessButtonTarget.classList.remove("hidden")
    }
  }

  // Triggered from any "destructive" button on the show page. Reads
  // params (url, method, title, body, submitLabel, submitClass) and
  // populates the shared confirm modal.
  openConfirm(event) {
    event && event.preventDefault()
    if (!this.hasConfirmModalTarget) return

    const t = event.currentTarget
    const url = t.dataset.confirmUrl || ""
    const method = (t.dataset.confirmMethod || "post").toLowerCase()
    const title = t.dataset.confirmTitle || "Are you sure?"
    const body = t.dataset.confirmBody || ""
    const submitLabel = t.dataset.confirmSubmitLabel || "Confirm"
    const submitClass = t.dataset.confirmSubmitClass ||
      "px-4 py-2 text-sm font-medium text-white bg-rose-600 rounded-lg hover:bg-rose-700 cursor-pointer"

    if (this.hasConfirmTitleTarget) this.confirmTitleTarget.textContent = title
    if (this.hasConfirmBodyTarget) this.confirmBodyTarget.innerHTML = body
    if (this.hasConfirmFormTarget) {
      this.confirmFormTarget.action = url
      // Rails forms use POST + a hidden _method override for non-GET.
      this.confirmFormTarget.method = (method === "get") ? "get" : "post"
    }
    if (this.hasConfirmMethodTarget) {
      this.confirmMethodTarget.value = ["post", "get"].includes(method) ? "" : method
    }
    if (this.hasConfirmSubmitTarget) {
      this.confirmSubmitTarget.textContent = submitLabel
      this.confirmSubmitTarget.className = submitClass
    }

    this.confirmModalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeConfirm(event) {
    event && event.preventDefault()
    if (this.hasConfirmModalTarget) {
      this.confirmModalTarget.classList.add("hidden")
    }
    document.body.style.overflow = ""
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
